import React from 'react';
import moment from 'moment';
import {
    Box,
} from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import './displayDate.component.scss';

const DisplayDate = ({label, date}) => {

    let d = moment(date);

    return (
        <Box className='dateWrapper' alignItems="center" style={{display: 'flex', minWidth: '200px'}}>
            <DateRangeIcon style={{fontSize:'20px'}} /> &nbsp; {label}: { (date && d.isValid()) ? d.format('MM-DD-YYYY') : 'N/A'}
        </Box>
    )

}

export default DisplayDate;